<div class="container-fluid mt-4">
  <!-- start page title -->
  <!-- <app-page-title title="Countries" [breadcrumbcoupons]="breadCrumbcoupons"></app-page-title> -->

  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-body">
          <div class="row mb-md-2">
            <div class="col-md-3">
              <!-- <div id="tickets-table_filter" class="dataTables_filter">
                <div class="d-flex">
                  <input
                    class="form-control"
                    type="text"
                    placeholder="Search Category"
                    (keyup)="searchCountry(searchTerm)"
                    [(ngModel)]="searchTerm"
                  />
                  <div class="d-flex" autocomplete="off">
                    <a
                      href="javascript:void(0)"
                      class="my-auto mx-2"
                      (click)="searchTerm = ''; searchCountry(searchTerm)"
                    >
                      <i class="fa fa-times text-danger"></i>
                    </a>
                  </div>
                </div>
              </div> -->
            </div>
            <div class="col-md-9 text-end">

              <button
                (click)="openAddorEditModal()"
                type="button"
                class="btn btn-success">
                <i class="mdi mdi-plus me-1"></i> Add Coupon
              </button>
            </div>
          </div>
          <!-- Table -->
          <div class="table-responsive">
            <table
              id="basic-datatable"
              class="table table-centered datatables dt-responsive nowrap table-card-list">
              <thead>
                <tr>
                  <th class="text-center">Coupon Code</th>
                  <th class="text-center">Created at</th>

                  <!-- <th class="text-center">Courier</th> -->
                  <th class="text-center">Discount %</th>
                  <th class="text-center">Offer Name</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let coupon of couponList; let i = index">
                  <td class="text-center">
                    {{ coupon?.coupon_code }}
                  </td>
                  <td class="text-center">
                    {{ coupon?.created_at * 1000 | date: 'medium' }}

                  </td>
                  <td class="text-center">
                    {{coupon?.discount}}%
                  </td>
                  <td class="text-center">
                    {{coupon?.offer_name}}
                  </td>

                  <!-- <td>
                    <div class="d-flex">
                      <div
                        class="form-check form-switch form-switch-lg m-auto"
                        dir="ltr"
                      >
                        <input
                          type="checkbox"
                          class="form-check-input"
                          id="hotel{{ i }}"
                          [disabled]="
                            !checkPermission(
                              'product_management_country_active'
                            )
                          "
                          [attr.checked]="category.display_status ? true : null"
                          (change)="changeStatus($event, category)"
                        />
                      </div>
                    </div>
                  </td>
                  <td>
                    <div class="d-flex">
                      <div
                        class="form-check form-switch form-switch-lg m-auto"
                        dir="ltr"
                      >
                        <input
                          type="checkbox"
                          class="form-check-input"
                          id="hotel{{ '0' }}"
                          [attr.checked]="category.courier_add ? true : null"
                          (change)="changeCourierStatus($event, category)"
                        />
                      </div>
                    </div>
                  </td> -->
                  <td
                    class="text-center"
                    (click)="openAddorEditModal(coupon)">
                    <a class="cpr"><i class="fas fa-edit text-info"></i></a>
                  </td>

                </tr>
              </tbody>
            </table>
          </div>

          <!-- <div *ngIf="isLoading" class="d-flex mt-5">
            <i class="fa fa-spin fa-spinner fa-pulse fa-5x m-auto"></i>
          </div> -->
          <!-- End table -->
          <div
            class="row justify-content-md-between align-items-md-center mt-2">
            <div class="col-sm-12 col-md-5">
              <div
                class="dataTables_info mb-2"
                id="tickets-table_info"
                role="status"
                aria-live="polite">
                Showing
                {{ (pageNumber - 1) * pageSize + 1 }} to
                {{
                pageNumber * pageSize < page_details.count
                ? pageNumber * pageSize
                : page_details.count
                }}
                of {{ page_details.count }} entries
              </div>
            </div>
            <!-- Pagination -->
            <div class="col-sm-12 col-md-5">
              <div class="text-md-end float-md-end pagination-rounded">
                <ngb-pagination
                  [collectionSize]="page_details.count"
                  [(page)]="pageNumber"
                  [pageSize]="pageSize"
                  (pageChange)="nextPage(pageNumber)">
                </ngb-pagination>
              </div>
            </div>
            <!-- End Pagination -->
          </div>
        </div>
      </div>
    </div>
  </div>
</div>